import { render } from "./GestionMenusNew.vue?vue&type=template&id=2b2c0192&scoped=true"
import script from "./GestionMenusNew.vue?vue&type=script&lang=js"
export * from "./GestionMenusNew.vue?vue&type=script&lang=js"

import "./GestionMenusNew.vue?vue&type=style&index=0&id=2b2c0192&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2c0192"]])

export default __exports__